/**
 * Mobile node height in pixels - taller for mobile devices
 */
export const MOBILE_NODE_HEIGHT_PX = 120;
